import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-upload-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M537.6 226.6C541.7 215.9 544 204.2 544 192 544 139 501 96 448 96 428.3 96 409.9 102 394.7 112.2 367 64.2 315.3 32 256 32 167.6 32 96 103.6 96 192 96 194.7 96.1 197.4 96.2 200.1 40.2 219.8 0 273.2 0 336 0 415.5 64.5 480 144 480H512C582.7 480 640 422.7 640 352 640 290.1 596 238.4 537.6 226.6zM393.4 288H328V400C328 408.8 320.8 416 312 416H264C255.2 416 248 408.8 248 400V288H182.6C168.3 288 161.2 270.8 171.3 260.7L276.7 155.3C282.9 149.1 293.1 149.1 299.3 155.3L404.7 260.7C414.8 270.8 407.6 288 393.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-upload-alt.js
// module id = HQHi
// module chunks = 144